import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import styled from 'styled-components';
import { useAccordion } from './Accordion';

type StylesProps = Partial<{ noPadding: boolean; isVisible: boolean }>;
const CardHeader = styled(Card.Header)`
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
`;

const Arrow = styled.i<StylesProps>`
  transform: ${({ isVisible }) => (isVisible ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: all 0.2s linear;
`;

const Content = styled.div<StylesProps>`
  padding: ${({ noPadding }) => (noPadding ? '0' : '1rem')};
`;

type CaretProps = { eventKey: string };
const Caret = ({ eventKey }: CaretProps) => {
  const [visibleTitle] = useAccordion();
  const isActive = visibleTitle === eventKey;

  return <Arrow isVisible={isActive} className="fa fa-fw fa-caret-right" />;
};

type Props = React.PropsWithChildren<{ title: string; noPadding?: boolean }>;
export const AccordionItem = (props: Props) => {
  const { title, children, noPadding } = props;
  const [, setVisible] = useAccordion();

  return (
    <Card className="mt-3">
      <Accordion.Toggle
        as={CardHeader}
        className="accordionHeader"
        eventKey={title}
        onClick={() => setVisible((e) => (e === title ? '' : title))}>
        <Caret eventKey={title} />
        &nbsp; {title}
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={title}>
        <Content noPadding={noPadding}>{children}</Content>
      </Accordion.Collapse>
    </Card>
  );
};
